import React from 'react';

import './EpLoading.scss';

interface EpLoadingProps {
  loadingId: string;
  loadingType?: 'page' | 'card';
  loadingColor?: 'green' | 'yellow' | 'red' | 'blue';
  isVisible: boolean;
  customClasses?: string;
  size?: 'md' | 'sm';
  position?: 'absolute' | 'relative';
  style?:object
}

export const EpLoading: React.FC<EpLoadingProps> = ({
  loadingId,
  loadingType = 'page',
  loadingColor = 'blue',
  isVisible = false,
  size = 'md',
  position = 'absolute',
  customClasses,
  style,
}) => {
  return (
    <div
      id={loadingId}
      className={`
        ep-loading
        ep-loading--${loadingColor}
        ep-loading--${loadingType}
        ${!isVisible ? 'ep-loading--hide' : ''}
        ${customClasses ? customClasses : ''}
        ${position === 'absolute' ? '' : 'ep-loading--card--relative'}
      `}
      style={style}
    >
      {loadingType === 'page' && <div className="ep-loading__backdrop"></div>}
      <div
          
        className={
          size === 'md'
            ? 'ep-loading__spinner'
            : 'ep-loading__spinner ep-loading__spinner--sm'
        }
      ></div>
    </div>
  );
};
